export default {
  title: 'ארכיון חיובים',
  notification: {
    errors: {
      find: {
        title: 'קיימת בעיה בהצגת הנתונים',
        message: 'לא ניתן למצוא הוצאות בארכיון אנא נסה שנית',
      },
    },
  },
};
